<template>
  <div class="NavGuestFavouriteItem flex my-2" v-visit="listing.path">
    <a :href="listing.path" class="inline-block mr-8 NavGuestFavouriteItem__img">
      <img :src="listing.thumbUrl" :alt="listing.title" class="NavGuestFavouriteItem__img" />
    </a>
    <section class="overflow-x-hidden">
      <a :href="listing.path" class="text-base text-black font-serif uppercase truncate">
        {{ listing.title }}
      </a>
      <div class="text-sm">
        <span class="text-grey">by</span>
        <a :href="listing.artist.path">
          {{ listing.artist.name }}
        </a>
      </div>
      <div class="text-xl text-grey-darker">
        {{ listing.total.format }}
      </div>
    </section>
    <div class="ml-auto">
      <a :href="listing.path" class="h-full px-4 flex items-center text-black">
        <i class="fal fa-chevron-right"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav.Guest.FavouriteItem",
  props: {
    listing: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.NavGuestFavouriteItem__img {
  min-width: 80px;
  width: 80px;
}
</style>

<style>
.NavGuestFavouriteItem + .NavGuestFavouriteItem {
  @apply mt-4;
}
</style>
